import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {Chatbot} from '../../states/actions';
import {useSelector, shallowEqual} from 'react-redux';
import {IntNodeComponent, SelectComp} from './Components';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

export const RouterBlock = React.memo((node) => {
  const {block, start} = useSelector(createSelectNodeData(node.id), shallowEqual);

  if (!block) {
    return null;
  }
  const {data} = block;

  return (
    <IntNodeComponent name="Router" icon="condition" data={data} node={node} start={start} />
  );
});

export const RouterEditor = ({block}) => {
  const {data} = block;
  const [addRouteValue, setAddRouteValue] = useState('');
  const [localRoutes, setLocalRoutes] = useState(data?.routes || {});

  useEffect(() => {
    setLocalRoutes(data?.routes || {});
  }, [data?.routes]);

  if (!block) {
    return null;
  }

  const variableoptions = Chatbot.getBlockVariables();

  const addRoute = (e) => {
    e.preventDefault();
    const value = addRouteValue.trim();
    if (!value) return;
    const id = moment().valueOf().toString();
    const updatedRoutes = {
      ...localRoutes,
      [id]: {id, value, next: null},
    };
    setLocalRoutes(updatedRoutes);
    Chatbot.setBlockData(block.id, {assign: {...data, routes: updatedRoutes}});
    setAddRouteValue('');
  };

  const removeRoute = (e, routeId) => {
    e.preventDefault();
    e.stopPropagation();
    Chatbot.removeRouterRoute(block.id, routeId);
    const updatedRoutes = {...localRoutes};
    delete updatedRoutes[routeId];
    setLocalRoutes(updatedRoutes);
  };

  const updateRouteValue = (routeId, newValue) => {
    const value = (newValue || '').trim();
    const existing = localRoutes[routeId];
    if (!existing) return;
    const updatedRoutes = {
      ...localRoutes,
      [routeId]: {...existing, value},
    };
    setLocalRoutes(updatedRoutes);
    Chatbot.setBlockData(block.id, {assign: {...data, routes: updatedRoutes}});
  };

  return (
    <>
      <div className="section">Router</div>
      <SelectComp
        data={data}
        name="Route variable"
        dataname="variable"
        placeholder="Select"
        options={variableoptions}
        block={block}
        value="label"
      />
      <small style={{display: 'block', fontStyle: 'italic', color: '#666', marginBottom: '12px'}}>
        Branches on the saved value of this variable. Use after a background AI block writes the result.
      </small>

      <div className="double-input mb-3">
        <div className="inputs">
          <input
            type="input"
            className="form-control"
            placeholder="Route value (e.g. refund)"
            value={addRouteValue}
            onChange={(e) => setAddRouteValue(e.target.value)}
            onKeyPress={(e) => (e.key === 'Enter' ? addRoute(e) : null)}
            onBlur={addRoute}
          />
        </div>
        <span className="icon" onClick={addRoute}>
          <i className="fa fa-plus"></i>
        </span>
      </div>

      {Object.values(localRoutes).map((route) => (
        <div key={route.id} className="double-input mb-3">
          <div className="inputs">
            <input
              className="form-control"
              placeholder="Route value"
              value={route.value}
              onChange={(e) => updateRouteValue(route.id, e.target.value)}
            />
          </div>
          <span className="icon red" onClick={(e) => removeRoute(e, route.id)}>
            <i className="fa fa-trash-alt"></i>
          </span>
        </div>
      ))}

      <p className="small text-muted mb-0">
        Connect each value to a flow branch on the node. Unmatched values use the Fallback exit (left handle).
      </p>
    </>
  );
};
